import { localizedPath } from '@it-tools/shell'
import type { ToolEntry } from './tools'

/**
 * Where a card should link for the language currently on screen.
 *
 * The locale is the first path segment site-wide, so a Portuguese visitor must
 * leave for `/pt-br/subnet-calculator/` rather than the English page — otherwise
 * every link out of the homepage silently resets the language. `localizedPath` in
 * the shell owns that rule; never assemble these by concatenation.
 *
 * Returns `null` for a tool with nothing to visit, which the card renders as plain
 * text instead of a dead link.
 */
export function toolHref(tool: ToolEntry, locale: string): string | null {
  if (tool.path === null) return null
  return localizedPath(tool.path, locale)
}
